import { BaseDto } from "src/dtos/common/baseDto";
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { OrganizationDto } from "src/dtos/organization/organizationDto";
import { CmailDto, SendTargetEmp } from "src/dtos/popbill/CmailDto";

export interface MST7020_R01Dto extends CmailDto {

	sendTarget: SendTargetEmp[];
}

export const defaultMST7020_R01Dto: MST7020_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	sendMsgId: 0,
	sendType: 'short',
	senderStatus: '',
	sender: '',
	senderName: '',
	receiver: '',
	receiverName: '',
	subject: '',
	msgContent: '',
	reserveDT: '',
	adsYN: false,
	requestNum: '',
	sendCompany: '',
	sendId: '',
	sendRegNo: '',
	sendEmpno: '',
	popbillReceiptNum: '',
	resultCode: '',
	resultMsg: '',
	remark: '',
	state: '',
	result: '',
	messageType: '',
	receiptDT: '',
	sendDT: '',
	resultDT: '',
	tranNet: '',
	receiptNum: '',
	interOPRefKey: '',
	
	sendTarget: [],

	inserted: false,
	isModified: false,
}